'use strict';

yalwa.browse = (function(pub) {
	pub = pub || {};
	
	pub.init = function() {
		if (yalwa.v.ai_badge_msg_ids && yalwa.v.ai_badge_msg_ids.length) {
			pub.add_ai_badges(yalwa.v.ai_badge_msg_ids);
		}
		if (jQuery('.js-description_snippet').length) {
			pub.update_description_snippets();
			jQuery(window).on('resize', () => {
				yalwa.basics.debounce(pub.update_description_snippets, 200);
			});
		}

		jQuery(document).on('click', '.js-vip_header_icon', function(e) {
			e.preventDefault();
			const dialog = document.getElementById('vip_visibility_dialog');
			if (dialog) {
				dialog.show();
			}
		});
	};
	
	pub.update_description_snippets = function() {
		jQuery('.js-description_snippet').each(function() {
			smart_snippet(jQuery(this));
		});
	};
	
	pub.add_ai_badges = function(msg_ids) {
		const ids = {};
		jQuery.each(msg_ids, function(i, id) {
			ids[id] = true;
		});
		jQuery('.js-bst_list_item[data-msgid]').each(function() {
			const $card = jQuery(this);
			if (!ids[$card.data('msgid')] || $card.find('.posting_listing__ai_badge').length) {
				return;
			}
			$card.find('.js-description_snippet').first().before(
				'<yalwa-badge class="posting_listing__ai_badge" intent="advanced" variant="fill" size="s" shape="round">'
				+ yalwa.v.ai_badge_icon + ' ' + yalwa.v.ai_badge_label + '</yalwa-badge>'
			);
		});
	};
	
	function get_keyword_index($highlighted, $root) {
		const range = document.createRange();
		range.setStart($root.get(0), 0);
		range.setEndBefore($highlighted.get(0));
		return range.toString().length;
	}
	
	function smart_snippet($e) {
		const max_lines = 3;
		
		if (!$e.data('original_html')) {
			$e.data('original_html', $e.html());
		} else {
			$e.html($e.data('original_html'));
		}
		
		const $highlighted = $e.find('strong');
		if ($highlighted.length === 0) {
			return;
		}
		
		const highlighted_html = $highlighted.get(0).outerHTML;
		const keyword_text = $highlighted.text();
		const full_text = $e.text();
		let keyword_index = get_keyword_index($highlighted, $e);
		if (keyword_index < 0 || keyword_index >= full_text.length) {
			keyword_index = full_text.indexOf(keyword_text);
		}
		
		const style = getComputedStyle($e.get(0));
		const line_height = parseFloat(style.lineHeight);
		const max_height = line_height * max_lines;
		const element_width = style.width;
		const box_sizing = style.boxSizing;
		const padding_top = parseFloat(style.paddingTop);
		const padding_bottom = parseFloat(style.paddingBottom);
		const border_top = parseFloat(style.borderTopWidth);
		const border_bottom = parseFloat(style.borderBottomWidth);
		const allowed_height = max_height + padding_top + padding_bottom + border_top + border_bottom + 1;
		
		const tokens = full_text.match(/\s+|\S+/g);
		if (!tokens) {
			return;
		}
		
		let char_count = 0;
		let center_token = 0;
		for (let i = 0; i < tokens.length; i++) {
			char_count += tokens[i].length;
			if (char_count > keyword_index) {
				center_token = i;
				break;
			}
		}
		
		const $clone = $e.clone().css({
			position: 'absolute',
			visibility: 'hidden',
			height: 'auto',
			maxHeight: 'none',
			overflow: 'visible',
			WebkitLineClamp: 'unset',
			display: 'block',
			width: element_width,
			boxSizing: box_sizing
		}).removeAttr('id').appendTo('body');
		
		let low = 1;
		let high = tokens.length;
		let best_snippet = '';
		while (low <= high) {
			const mid = Math.floor((low + high) / 2);
			const snippet = build_tokens_snippet(mid, center_token, tokens, keyword_text, highlighted_html);
			$clone.html(snippet);
			const height = $clone.get(0).getBoundingClientRect().height;
			if (height <= allowed_height) {
				best_snippet = snippet;
				low = mid + 1;
			} else {
				high = mid - 1;
			}
		}
		
		$clone.remove();
		
		if (best_snippet) {
			$e.html(best_snippet);
		}
	}
	
	function build_tokens_snippet(tokenCount, center_token, tokens, keyword_text, highlighted_html) {
		const half = Math.floor(tokenCount / 2);
		let start = center_token - half;
		if (start < 0) {
			start = 0;
		}
		let end = start + tokenCount;
		if (end > tokens.length) {
			end = tokens.length;
			start = end - tokenCount;
			if (start < 0) {
				start = 0;
			}
		}
		
		const snippet_tokens = tokens.slice(start, end);
		let snippet;
		if (/\s/.test(keyword_text)) {
			snippet = snippet_tokens.join('');
			snippet = snippet.replace(keyword_text, highlighted_html);
		} else {
			const rel = center_token - start;
			snippet_tokens[rel] = snippet_tokens[rel].replace(keyword_text, highlighted_html);
			snippet = snippet_tokens.join('');
		}
		
		if (start > 0) {
			snippet = '…' + snippet;
		}
		if (end < tokens.length) {
			snippet += '…';
		}
		return snippet;
	}
	
	return pub;
	
}(yalwa.browse));
if (yalwa.v.routing !== 'vap') {
	yalwa.browse.init();
}

